import { FIELD_TYPES } from "constants/template-field-type";
import { CONTACT_SALES_HUBSPOT_FORM_ID, CONTACT_SALES_LANDING_PAGE_SERVICE_FORM_ID, CONTACT_SALES_LANDING_PAGE_CRM_FORM_ID, CONTACT_SALES_LANDING_PAGE_AGENT_FACTORY_FORM_ID, CONTACT_SALES_LANDING_PAGE_WORK_MANAGEMENT_FORM_ID, CONTACT_SALES_LANDING_PAGES_FDES_FORM_ID, CONTACT_SALES_LANDING_PAGE_MONDAY_VIBE_FORM_ID, CONTACT_SALES_LANDING_PAGE_GENERAL_FORM_ID, CONTACT_US_MOBILE_CONTACT_SALES_FORM_ID, CONTACT_SALES_EXPANSION_FORM_ID, CONTACT_SALES_WEBSITE_CRM_FORM_ID } from "client/services/hubspot-service/contact-form-config";
const NEW_FORM_OPTIONS = [
    {
        value: CONTACT_SALES_HUBSPOT_FORM_ID,
        text: `Homepage | Contact Sales (${CONTACT_SALES_HUBSPOT_FORM_ID})`
    },
    {
        value: CONTACT_SALES_LANDING_PAGE_SERVICE_FORM_ID,
        text: `Landing Page | Service (${CONTACT_SALES_LANDING_PAGE_SERVICE_FORM_ID})`
    },
    {
        value: CONTACT_SALES_LANDING_PAGE_CRM_FORM_ID,
        text: `Landing Page | CRM (${CONTACT_SALES_LANDING_PAGE_CRM_FORM_ID})`
    },
    {
        value: CONTACT_SALES_LANDING_PAGE_AGENT_FACTORY_FORM_ID,
        text: `Landing Page | Agent Factory (${CONTACT_SALES_LANDING_PAGE_AGENT_FACTORY_FORM_ID})`
    },
    {
        value: CONTACT_SALES_LANDING_PAGE_WORK_MANAGEMENT_FORM_ID,
        text: `Landing Page | Work Management (${CONTACT_SALES_LANDING_PAGE_WORK_MANAGEMENT_FORM_ID})`
    },
    {
        value: CONTACT_SALES_LANDING_PAGES_FDES_FORM_ID,
        text: `Landing Pages | FDEs (${CONTACT_SALES_LANDING_PAGES_FDES_FORM_ID})`
    },
    {
        value: CONTACT_SALES_LANDING_PAGE_MONDAY_VIBE_FORM_ID,
        text: `Landing Page | monday Vibe (${CONTACT_SALES_LANDING_PAGE_MONDAY_VIBE_FORM_ID})`
    },
    {
        value: CONTACT_SALES_LANDING_PAGE_GENERAL_FORM_ID,
        text: `Landing Page | General (${CONTACT_SALES_LANDING_PAGE_GENERAL_FORM_ID})`
    },
    {
        value: CONTACT_US_MOBILE_CONTACT_SALES_FORM_ID,
        text: `Mobile Contact Sales (${CONTACT_US_MOBILE_CONTACT_SALES_FORM_ID})`
    },
    {
        value: CONTACT_SALES_EXPANSION_FORM_ID,
        text: `Expansion (${CONTACT_SALES_EXPANSION_FORM_ID})`
    },
    {
        value: CONTACT_SALES_WEBSITE_CRM_FORM_ID,
        text: `Website | CRM (${CONTACT_SALES_WEBSITE_CRM_FORM_ID})`
    }
];
export default {
    formId: {
        type: FIELD_TYPES.COMBO,
        options: NEW_FORM_OPTIONS,
        label: "Form ID"
    },
    formTitle: {
        type: FIELD_TYPES.TEXT,
        label: "Form Title"
    },
    formSubTitle: {
        type: FIELD_TYPES.TEXT,
        label: "Form SubTitle"
    },
    urlToRedirectAfterSubmission: {
        type: FIELD_TYPES.TEXT,
        label: "URL to redirect after submission (default URL)"
    },
    dontRenderPostFormSubmit: {
        type: FIELD_TYPES.BOOLEAN,
        label: "Don't render post form submit"
    },
    sendEmailToEnrichment: {
        type: FIELD_TYPES.BOOLEAN,
        label: "Send email to enrichment"
    }
};
